<template>
  <section class="donation-prep-section">
    <h2><strong>เช็คความพร้อม 10 ข้อ!</strong> ก่อนพามาบริจาคเลือด</h2>
    <container>
      <div class="col donation-step-container">
        <div class="red-line"></div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-prep-1.png" alt="blood donation step">
          <span class="number">1.</span>
          <span class="content">สุนัขตอายุตั้งแต่ 1-7ปี สุขภาพดี กินได้ปกติ ขับถ่ายปกติ น้ำหนัก>17kg</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-prep-2.png" alt="blood donation step">
          <span class="number">2.</span>
          <span class="content">แมวอายุตั้งแต่ 1-7 ปี เลี้ยงในระบบปิด มีสุขภาพดี น้ำหนัก>4kg</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-prep-3.png" alt="blood donation step">
          <span class="number">3.</span>
          <span class="content">ไม่อยู่ในช่วงของการเป็นสัด ไม่อยู่ในช่วงตั้งท้อง หรือให้นมลูก</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-prep-4.png" alt="blood donation step">
          <span class="number">4.</span>
          <span class="content">ฉีดวัคซีนครบและผ่านมาอย่างน้อย 2-4 สัปดาห์</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-prep-5.png" alt="blood donation step">
          <span class="number">5.</span>
          <span class="content">มีการป้องกันเห็บหมัดและพยาธิหนอนหัวใจเป็นประจำ</span>
        </div>
      </div>
    </container>
    <container>
      <div class="col donation-step-container">
        <div class="red-line"></div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-prep-6.png" alt="blood donation step">
          <span class="number">6.</span>
          <span class="content">ไม่ป่วยเป็นโรคติดต่อหรือโรคเรื้อรังต่างๆ</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-prep-7.png" alt="blood donation step">
          <span class="number">7.</span>
          <span class="content">ไม่เคยได้รับการถ่ายเลือด</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-prep-8.png" alt="blood donation step">
          <span class="number">8.</span>
          <span class="content">ไม่ได้รับการผ่าตัดใหญ่ในระยะ 3 เดือนที่ผ่านมา</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-prep-9.png" alt="blood donation step">
          <span class="number">9.</span>
          <span class="content">บริจาคเลือดครั้งสุดท้ายมาเกิน 3 เดือน</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-prep-10.png" alt="blood donation step">
          <span class="number">10.</span>
          <span class="content">ไม่ได้รับประทานยาในช่วง 2 สับดาห์</span>
        </div>
      </div>
    </container>
  </section>
</template>

<script>
import Container from '@/components/Container.vue'

export default {
  name: 'DonationPrepSection',
  components: {
    Container
  }
}
</script>

<style lang="scss">
.donation-prep-section {
  background-color: $gray-100;
  padding: 2rem 0;
  h2 {
    text-align: center;
    font-size: $h3-font-size;
    font-weight: $font-weight-light;
    strong {
      font-weight: $font-weight-normal;
    }
  }
}
.donation-step-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  .donation-step {
    display: flex;
    flex-direction: row;
    margin: 0.5rem 0rem;
    z-index: 1;
    img {
      width: 5rem;
      height: 5rem;
      object-fit: contain;
    }
    span {
      align-self: center;
    }
    .number {
      font-size: $h3-font-size;
      font-weight: $font-weight-bold;
      text-align: center;
      margin-left: 0.5rem;
    }
    .content {
      margin-left: 0.5rem;
    }
  }
  .red-line {
    display: none;
  }
}
@media (min-width: map-get($grid-breakpoints, "md")) {
  .donation-prep-section {
    h2 {
      font-size: $h1-font-size;
    }
  }
  .donation-step-container {
    flex-direction: row;
    .donation-step {
      flex-direction: column;
      flex-basis: 0;
      margin: 0.5rem 1rem;
      text-align: center;
      img {
        width: 7rem;
        height: 7rem;
        margin: 0 auto;
      }
      .number {
        font-size: $h3-font-size;
      }
    }
    .red-line {
      display: block;
      position: absolute;
      background-color: $primary-dark;
      top: 3.7rem;
      width: 32rem;
      height: 0.75rem;
    }
  }
}
@media (min-width: map-get($grid-breakpoints, "lg")) {
  .donation-step-container {
    .donation-step {
      margin: 0.5rem 2rem;
      img {
        width: 9rem;
        height: 9rem;
      }
    }
    .red-line {
      top: 4.7rem;
      width: 45rem;
      height: 0.75rem;
    }
  }
}
</style>
